var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Header,{attrs:{"items":_setup.headerItems},on:{"trigger":_setup.triggerWorkflow}})
}
var staticRenderFns = []

export { render, staticRenderFns }